import React from 'react'
import { observer } from 'mobx-react-lite'

import { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete/Autocomplete'

import { ExternalProductPicker, ProductSinglePickerBaseProps } from './ExternalProductPicker'

import { useLogic } from '../../hooks/storeHook'
import { BootstrapInput } from '../BootstrapInput'

export const WbProductSinglePicker =
  observer(
    ({msProductId, ...passProps}: ProductSinglePickerBaseProps) => {
      const logic = useLogic()

      return (
        <ExternalProductPicker
          loadOptions={searchTerm => logic.loadWbProductOptions(msProductId, searchTerm)}
          renderInput={renderWbInput}
          {...passProps}
        />
      )
    })

export const renderWbInput =
  (props: AutocompleteRenderInputParams) => {
    const {InputProps, InputLabelProps /* ignored */, ...passProps} = props

    return (
      <BootstrapInput
        {...passProps}
        {...InputProps}
        autoFocus
        multiline
        maxRows={3}
        placeholder="Артикул / Штрихкод / Код размера"
        style={{fontSize: 12}}
      />
    )
  }